
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import heroImg from '../../../assets/ska/mainFeed.webp'
import logo from '../../../assets/ska/logo.jpeg'

import ameneties1 from '../../../assets/ska/ameneties-1.webp'
import ameneties2 from '../../../assets/ska/ameneties-2.png'
import ameneties3 from '../../../assets/ska/ameneties-3.png'
import ameneties4 from '../../../assets/ska/ameneties-4.png'
import ameneties5 from '../../../assets/ska/ameneties-5.png'

import interior1 from '../../../assets/ska/interior-1.jpg'
import interior2 from '../../../assets/ska/interior-2.webp'
import interior3 from '../../../assets/ska/interior-3.jpg'
import interior4 from '../../../assets/ska/interior-4.jpg'
import interior5 from '../../../assets/ska/interior-5.jpg'


import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';


const Ska = () => {
  const location = useLocation();
  const [openImgModal, setOpenImgModal] = useState(false);

  const [selectedImgIndex, setSelectedImgIndex] = useState(null);
  const [activeImageType, setActiveImageType] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const interiors = [interior1, interior2, interior3, interior4, interior5]
  const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);


  const handleOpenModal = (index, type) => {
    setSelectedImgIndex(index);
    setActiveImageType(type);
    setOpenImgModal(true);
  }

  return (
    <div className="w-full min-h-screen bg-gray-100">
      <div
        className="w-full h-[700px] bg-cover bg-center transition-all duration-500"
        style={{ backgroundImage: `url('${heroImg}')` }}
      ></div>

      <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
        <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
          <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
        </div>
      </div>

      <div class="flex flex-col md:flex-row px-2.5 gap-4">
        <div class="w-full md:w-2/3 flex flex-col gap-4">
          <div className="">
            <div className="max-w-5xl mx-auto p-6">
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                The SKA Group has introduced an exciting new residential project, **SKA Eta 2**, located in the
                thriving area of Greater Noida, near the Yamuna Expressway. This development is designed to offer a
                luxurious and modern lifestyle, blending contemporary architecture with state-of-the-art amenities.
                Here's a detailed description:
              </p>
              <h2 className="text-2xl md:text-3xl font-bold my-2">Key Features:</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Location:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Strategically positioned near the Yamuna Expressway, SKA Eta 2 enjoys excellent
                    connectivity to Delhi, Noida, and Agra. It is also close to the upcoming Jewar International Airport,
                    making it a prime location for both residents and investors.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Configuration:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project offers a range of 3 BHK and 4 BHK luxury apartments, catering to
                    diverse family sizes and preferences.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Clubhouse:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A lavish 1,55,000+ sq. ft. clubhouse equipped with world-class amenities.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Unit Sizes:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The apartments are spacious, with sizes ranging from approximately 1500 sq. ft. to
                    2200 sq. ft., ensuring ample living space for residents.
                  </p>
                </div>
              </section> 


              <h2 className="text-2xl md:text-3xl font-bold my-4">Amenities :</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Clubhouse:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A modern clubhouse equipped with facilities for recreation and social gatherings.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Fitness Center:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A fully-equipped gymnasium and spaces for yoga and meditation.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Swimming Pool:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A large swimming pool with a separate kids' pool for family enjoyment.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Sports Facilities</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Outdoor courts for basketball, tennis, and cricket, along with jogging tracks
                    and landscaped gardens.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Children's Play Area:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A safe and engaging space for kids to play and explore.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Community Spaces:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A multi-purpose hall for events and gatherings, fostering a sense of
                    community among residents.
                  </p>
                </div>
              </section>

              <h2 className="text-2xl md:text-3xl font-bold my-4">Highlights :</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Connectivity:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project is well-connected via the Yamuna Expressway and the Noida-Greater
                    Noida Expressway. The upcoming metro expansion and proximity to IT hubs, educational institutions,
                    and healthcare facilities add to its appeal
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Sustainability:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    SKA Eta 2 incorporates eco-friendly practices, including rainwater harvesting and
                    energy-efficient systems.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Security:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    A gated community with 24/7 security, CCTV surveillance, and power backup ensures
                    a safe and comfortable living environment
                  </p>
                </div>
              </section>

              <h2 className="text-2xl md:text-3xl font-bold my-4">Why Choose SKA :</h2>
              <section className="p-4 md:p-6 bg-gray-100 text-gray-900 rounded-lg">
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Prime Location:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    Its proximity to major infrastructure projects like the Jewar International
                    Airport and the Delhi-Mumbai Industrial Corridor makes it a promising investment.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Luxury Living:</h3>
                  <p className="text-md text-gray-700 text-justify">
                    The project offers a blend of comfort, style, and convenience, making it an ideal
                    choice for families and professionals.
                  </p>
                </div>
                <div className="max-w-4xl mx-auto mb-6">
                  <h3 className="font-semibold text-xl md:text-2xl mb-2">Developer Reputation :</h3>
                  <p className="text-md text-gray-700 text-justify">
                    SKA Group is known for delivering high-quality residential projects with
                    a focus on customer satisfaction and timely delivery.
                  </p>
                </div>
              </section>
              <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                This project is a testament to SKA Group's commitment to creating modern and luxurious living
                spaces. Whether you're looking for a dream home or a smart investment, SKA Eta 2 offers an
                unparalleled opportunity in one of the fastest-growing regions of the NCR.
              </p>
            </div>
          </div>
        </div>
        <ConnectForm />
      </div>
      <div className="max-w-7xl mx-auto p-4">
        <h2 className="text-2xl font-semibold text-gray-800 my-4">
          Projects Highlights
        </h2>
        {openImgModal && activeImageType === "ameneties" && (
          <ImageModal
            images={ameneties}
            openImg={openImgModal}
            selectedImgIndex={selectedImgIndex}
            onClose={() => setOpenImgModal(false)}
          />
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {ameneties.map((data, index) => (
            <div
              key={index}
              onClick={() => handleOpenModal(index, "ameneties")}
              className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
            >
              <img
                src={data}
                alt="ATS"
                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
      <h2 className="text-2xl font-semibold text-gray-800 p-4">
        Luxury  Insights

      </h2>
      {openImgModal && activeImageType === "interiors" && (
        <ImageModal
          images={interiors}
          openImg={openImgModal}
          selectedImgIndex={selectedImgIndex}
          onClose={() => setOpenImgModal(false)}
        />
      )}

      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
        {interiors.map((data, index) => (
          <div
            key={index}
            onClick={() => handleOpenModal(index, "interiors")}
            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
          >
            <img
              src={data}
              alt="ATS"
              className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  )
}
export default Ska